import styled from "styled-components";

import {
    VOTEBOX_ACCENT_COLOR,
    VOTEBOX_FONT_SIZE_SMALL,
    VOTEBOX_FONT_WEIGHT_BOLD,
    VOTEBOX_ICON_SIZE,
    VOTEBOX_TEXT_BUTTON_MIN_HEIGHT,
} from "../voteboxTokens";
import { TextButton } from "./TextButton";

export const StyledButton = styled(TextButton)`
    display: flex;
    align-items: center;
    gap: 8px;
    min-height: ${VOTEBOX_TEXT_BUTTON_MIN_HEIGHT};
    margin-bottom: 0.5rem;
    padding: 0 4px;
    color: ${VOTEBOX_ACCENT_COLOR};
    font-size: ${VOTEBOX_FONT_SIZE_SMALL};
    font-weight: ${VOTEBOX_FONT_WEIGHT_BOLD};
    cursor: pointer;
    .MuiSvgIcon-root {
        font-size: ${VOTEBOX_ICON_SIZE};
    }
`;
